import MoreIcon from "@/assets/svg/more.svg?react";
import { PopoverContent } from "@/components/ui/popover";

import { Popover, PopoverTrigger } from "@radix-ui/react-popover";

type DashboardActionCellProps<TData> = {
  data: TData;
  onViewClick?: (data: TData) => void;
  onEditClick?: (data: TData) => void;
  onDeleteClick?: (data: TData) => void;
  viewPermission?: boolean;
  editPermission?: boolean;
  deletePermission?: boolean;
};

const DashboardActionCell = <TData,>({
  data,
  onViewClick = () => {},
  onEditClick = () => {},
  onDeleteClick = () => {},
  viewPermission = true,
  editPermission = false,
  deletePermission = false
}: DashboardActionCellProps<TData>) => (
  <div className="flex justify-center">
    <Popover>
      <PopoverTrigger asChild>
        <button
          aria-label="more actions"
          data-testid="dashboard-action-trigger"
          className="p-2 rounded-full hover:bg-gray-100"
        >
          <MoreIcon
            className="w-4 h-4"
            title="Dashboard Action Cell Icon Action"
          />
        </button>
      </PopoverTrigger>
      <PopoverContent
        className="flex flex-col p-0 rounded-xl overflow-hidden w-[96px]"
        align="end"
        side="bottom"
        sideOffset={0}
      >
        {viewPermission && (
          <button
            data-testid="action-view-test"
            onClick={() => {
              onViewClick?.(data);
            }}
            className="text-left text-xs leading-6 px-3 py-[6px] hover:bg-neutral-50"
          >
            View
          </button>
        )}

        {editPermission && (
          <button
            data-testid="action-edit-test"
            onClick={() => {
              onEditClick?.(data);
            }}
            className="text-left text-xs leading-6 px-3 py-[6px] hover:bg-neutral-50"
          >
            Edit
          </button>
        )}
        {deletePermission && (
          <button
            data-testid="action-delete-test"
            onClick={() => {
              onDeleteClick?.(data);
            }}
            className="text-left text-xs leading-6 px-3 py-[6px] hover:bg-neutral-50"
          >
            Delete
          </button>
        )}
      </PopoverContent>
    </Popover>
  </div>
);

export default DashboardActionCell;
